import { withStyles, withTheme, Theme, Divider } from '@material-ui/core';

export const CustomDivider = withStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(2, 0),
  },
}))(withTheme(Divider));
